/**
 * Lightweight stable device fingerprint for trusted-device login.
 * Not invasive canvas/WebGL fingerprinting — coarse browser signals only.
 */
export async function getDeviceFingerprint(): Promise<string> {
    if (typeof window === 'undefined') {
        return 'server'
    }

    const parts = [
        navigator.userAgent || '',
        navigator.language || '',
        navigator.platform || '',
        Intl.DateTimeFormat().resolvedOptions().timeZone || '',
        String(screen.width),
        String(screen.height),
        String(window.devicePixelRatio ?? 1),
        String(navigator.hardwareConcurrency ?? 0),
    ]

    const raw = parts.join('|')
    const encoder = new TextEncoder()
    const data = encoder.encode(raw)
    const digest = await crypto.subtle.digest('SHA-256', data)
    const bytes = Array.from(new Uint8Array(digest))
    return bytes.map((b) => b.toString(16).padStart(2, '0')).join('')
}
